import { render, staticRenderFns } from "./IconAppid.vue?vue&type=template&id=0460be60&"
import script from "./IconAppid.vue?vue&type=script&lang=js&"
export * from "./IconAppid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports